<template>
  <div>
    <template v-if="!isMobile">
      <CourseCarouselSectionOne
        v-for="(tag, i) in curatedTags.slice(0, 4)"
        :key="`${tag}-${i}`"
        :tag="tag"
        :presenters="presenters"
        :isCordova="isCordova"
      />
      <CourseCarouselSectionTwo
        v-for="(tag, i) in curatedTags.slice(4, 9)"
        :key="`${tag}-${i}`"
        :tag="tag"
        :presenters="presenters"
        :isCordova="isCordova"
      />
      <CourseCarouselSectionThree
        v-for="(tag, i) in curatedTags.slice(9, 14)"
        :key="`${tag}-${i}`"
        :tag="tag"
        :presenters="presenters"
        :isCordova="isCordova"
      />
      <CourseCarouselSectionFour
        v-for="(tag, i) in curatedTags.slice(14, 19)"
        :key="`${tag}-${i}`"
        :tag="tag"
        :presenters="presenters"
        :isCordova="isCordova"
      />
      <CourseCarouselSectionFive
        v-for="(tag, i) in curatedTags.slice(19, 100)"
        :key="`${tag}-${i}`"
        :tag="tag"
        :presenters="presenters"
        :isCordova="isCordova"
      />
    </template>
    <template v-else>
      <MobileCourseCarouselSectionOne
        v-for="(tag, i) in curatedTags.slice(0, 4)"
        :key="`${tag}-${i}`"
        :tag="tag"
      />
      <MobileCourseCarouselSectionTwo
        v-for="(tag, i) in curatedTags.slice(4, 9)"
        :key="`${tag}-${i}`"
        :tag="tag"
      />
      <MobileCourseCarouselSectionThree
        v-for="(tag, i) in curatedTags.slice(9, 14)"
        :key="`${tag}-${i}`"
        :tag="tag"
      />
      <MobileCourseCarouselSectionFour
        v-for="(tag, i) in curatedTags.slice(14, 19)"
        :key="`${tag}-${i}`"
        :tag="tag"
      />
      <MobileCourseCarouselSectionFive
        v-for="(tag, i) in curatedTags.slice(19, 100)"
        :key="`${tag}-${i}`"
        :tag="tag"
      />
    </template>
  </div>
</template>

<script>
import { lazyLoadComponent } from '@/helpers'
import LazyLoadingSpinner from '@/components/layout/LazyLoadingSpinner.vue'

export default {
  name: 'CarouselsByTags',
  components: {
    CourseCarouselSectionOne: lazyLoadComponent({
      componentFactory: () => import('@/components/home-page/CourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    CourseCarouselSectionTwo: lazyLoadComponent({
      componentFactory: () => import('@/components/home-page/CourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    CourseCarouselSectionThree: lazyLoadComponent({
      componentFactory: () => import('@/components/home-page/CourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    CourseCarouselSectionFour: lazyLoadComponent({
      componentFactory: () => import('@/components/home-page/CourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    CourseCarouselSectionFive: lazyLoadComponent({
      componentFactory: () => import('@/components/home-page/CourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    MobileCourseCarouselSectionOne: lazyLoadComponent({
      componentFactory: () =>
        import('@/components/home-page/MobileCourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    MobileCourseCarouselSectionTwo: lazyLoadComponent({
      componentFactory: () =>
        import('@/components/home-page/MobileCourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    MobileCourseCarouselSectionThree: lazyLoadComponent({
      componentFactory: () =>
        import('@/components/home-page/MobileCourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    MobileCourseCarouselSectionFour: lazyLoadComponent({
      componentFactory: () =>
        import('@/components/home-page/MobileCourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
    MobileCourseCarouselSectionFive: lazyLoadComponent({
      componentFactory: () =>
        import('@/components/home-page/MobileCourseCarousel'),
      loading: LazyLoadingSpinner,
    }),
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
    presenters: {
      type: Array,
      required: true,
    },
    isCordova: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      curatedTags: [
        'Amazon',
        'Automation Systems',
        'CCNA',
        'CCNP',
        'CCIE',
        'Certified Ethical Hacker',
        'Collaboration',
        'Data Center',
        'DevOps',
        'EC-Council',
        'Google',
        'Juniper',
        'Microsoft',
        'Network Security',
        'Python',
        'Routing & Switching',
        'SDN',
        'Security',
        'Service Provider',
        'VMware',
        'Wireless',
      ],
    }
  },
}
</script>
